import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import ModelDrawer from '../../ModelDrawer';
import {
  navigateToScene,
  SceneProps,
  SceneSideDrawerRoute,
  withCurrentSearch
} from '../scene-utils';
import { Model } from '../../hooks/useModelState';
import BulkEditPanel from './BulkEditPanel';
import { resetBulkEditSceneState } from './bulkEditSceneState';

const bulkEditSceneSideDrawerRoutes = (
  model: Model,
  _path: string,
  _baseUrl: string,
  currentDrawerState: boolean,
  setDrawerStateCallback: (isOpen: boolean) => void,
  handleBackCallback: () => void,
): SceneSideDrawerRoute[] => [
    {
      path: '*',
      isOpen: currentDrawerState,
      setIsOpen: setDrawerStateCallback,
      component: model && <BulkEditPanel model={model} />,
      backNavText: 'Stopes', // msgid; ModelDrawer translates it
      onBack: handleBackCallback,
    },
  ];

const SideDrawerContent = ({ props, model }: { props: SceneProps; model: Model }) => {
  const location = useLocation();

  const handleBack = () => {
    resetBulkEditSceneState();
    navigateToScene('DEFAULT', { model, context: props.context });
  };

  React.useEffect(() => {
    if (!location.pathname.includes('/bulk-edit')) {
      const overviewIdx = location.pathname.indexOf('/overview');
      if (overviewIdx !== -1) {
        const basePath = location.pathname.substring(0, overviewIdx + '/overview'.length);
        props.context.actions.navigate(withCurrentSearch(`${basePath}/stopes/bulk-edit`), { replace: true });
      }
    }
  }, []);

  const routes = bulkEditSceneSideDrawerRoutes(
    model,
    props.meta.path,
    props.meta.url,
    props.context.state.drawerOpen,
    props.context.actions.setDrawerOpen,
    handleBack,
  );

  return (
    <Routes>
      {routes.map((route) => (
        <Route
          key={route.path}
          path={route.path}
          element={(
            <ModelDrawer
              isOpen={route.isOpen}
              setIsOpen={route.setIsOpen}
              backNavText={route.backNavText as string}
              onBack={handleBack}
            >
              {route.component}
            </ModelDrawer>
          )}
        />
      ))}
    </Routes>
  );
};

const sideDrawerContent = (
  props: SceneProps,
  model: Model,
): JSX.Element => (
  <SideDrawerContent props={props} model={model} />
);

export default sideDrawerContent;
